module.exports = __webpack_public_path__ + "static/media/lpf_left.8b1dc14d.png";